import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  throw new Error('Supabase env variables saknas. Kontrollera VITE_SUPABASE_URL och VITE_SUPABASE_ANON_KEY.');
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

/**
 * Storage-bucketarna används inte av appen.
 *
 * En BUCKETS-konstant pekade tidigare ut `intranet-dokument`, `Linneas
 * AI-losning` och `Quiz dokument`, men ingen kod läste den — det finns inte ett
 * enda `.storage`-anrop i vare sig src/ eller netlify/. Kunskapsbasen läser
 * numera ur `kb_chunks_v2`, inte ur filer.
 *
 * Konstanten är borttagen eftersom den fick kodbasen att se ut som om
 * dokumentbanken fortfarande hämtade filer därifrån. Filerna i bucketarna är
 * källmaterial som indexerats in i kunskapsbasen, inget appen läser vid drift.
 */
